(ns practitest.frontend.gauge-chart
  (:require
    [practitest.frontend.common.utils :as utils]
    [practitest.frontend.components.charts :as charts]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.init :as init]
    [re-frame.core :as re-frame]))

;; subs
(re-frame/reg-sub
  ::state
  (fn [db _]
    (:gauge-state db)))

(re-frame/reg-sub
  ::title
  :<- [::state]
  (fn [state [_ id]]
    (get-in state [id :data-title])))

(re-frame/reg-sub
  ::filter
  :<- [::state]
  (fn [state [_ id]]
    (get-in state [id :data-filter])))


(re-frame/reg-sub
  ::percentage
  :<- [::state]
  (fn [state [_ id]]
    (get-in state [id :data-percentage])))

(re-frame/reg-sub
  ::areas
  :<- [::state]
  (fn [state [_ id]]
    (cljs.reader/read-string (get-in state [id :data-areas]))))

;; events
(re-frame/reg-event-db
  ::write-attrs-to-db
  (fn [db [_ data]]
    (let [item-id (:data-item-id data)]
      (update-in db [:gauge-state item-id] merge data))))


(defn display-gauge [data-item-id data-uri]
  [:div.canvas-container
   [:div.canvas
      [charts/percentage-gauge-with-needle {:item-id    data-item-id
                                          :percentage @(re-frame/subscribe [::percentage data-item-id])
                                          :title      @(re-frame/subscribe [::title data-item-id])
                                          :areas      @(re-frame/subscribe [::areas data-item-id])
                                          :filter     @(re-frame/subscribe [::filter data-item-id])
                                          }]]
      [:a.edit-button
      {:href data-uri}
      [icons/pencil-fill]]])

(defn root-view [{:keys [data-item-id
                         data-percentage
                         data-title
                         data-colors
                         data-areas
                         data-filter
                         data-uri]
                  :as   attrs}]

  (re-frame/dispatch [::write-attrs-to-db attrs])
  [display-gauge data-item-id data-uri])


(defn ^:dev/after-load remount-roots []
  ;; remount all comment item components on page
  (init/remount-roots "gauge-chart-component"
                      root-view))

(utils/register-webcomponent! "gauge-chart-component")
